import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { layoutReducer } from './state/layout.reducer';
import { ResponsiveService } from './service/responsive/responsive.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('layout', layoutReducer),
    // EffectsModule.forFeature([])
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [ResponsiveService],
      useFactory: () => null,
    },
  ],
})
export class ObjectSearchLayoutModule {}
